import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AngularFireFunctions } from '@angular/fire/functions';
import { PaymentSourceService } from '@app/core/services/payment-source.service';
import { AuthService } from '@app/core/auth/auth.service';

@Component({
  selector: 'app-card-listing',
  templateUrl: './card-listing.component.html',
  styleUrls: ['./card-listing.component.css']
})
export class CardListingComponent implements OnInit {
  cardsouce$: Observable<any>;
  private stripeCustomerID;

  constructor(private paySrcSvc: PaymentSourceService, private fun: AngularFireFunctions, private authService: AuthService) { }

  ngOnInit() {
    this.cardsouce$ = this.paySrcSvc.getCards(JSON.parse(localStorage.getItem('user')).uid);
    this.authService.user.subscribe(user => {
      if (user) {
        // get stripe customer ID
        this.stripeCustomerID = user.stripeId;
      }
    });
  }

  async updateCard(cardId, fingerprint) {
    console.log('updateCard', cardId);
    try {
      const data = {
        customer_Id: this.stripeCustomerID,
        card_Id: cardId,
        fingerprint
      };
      const customer = await this.fun.httpsCallable('deleteStripeCard')(data).toPromise();

      // todo insert add card function here
      console.log('customercharging:', customer);
    } catch (error) {
      console.log('deleteCarderror:', error);
    }
  }

  async deleteCard(cardId, fingerprint) {
    console.log('deleteCard', cardId);
    try {
      const data = {
        customer_Id: this.stripeCustomerID,
        card_Id: cardId,
        fingerprint
      };
      const customer = await this.fun.httpsCallable('deleteStripeCard')(data).toPromise();
      console.log('deleting card:', customer);
    } catch (error) {
      console.log('deleteCarderror:', error);
    }
  }

}
